import React, { useRef } from 'react';

import { ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';

import { BRIDGE_KEYS, LayerDataBridge } from '../../../shared/utils/layer-data-bridge';
import { useLayerManager } from '../../../shared/hooks/use-layer-manager';

export type ResetPinLayerData = {
  authService: any;
  translationHandler: (key: string) => string;
  trackingManager: any;
  localeCode: string;
  isCanada: boolean;
  onSuccess: () => void;
  onChange: () => void;
};

type ResetPinLayerRenderFn = (
  state: { dataBridge: LayerDataBridge<ResetPinLayerData> },
  close: any,
) => JSX.Element;

export const useResetPinLayer = (
  active: boolean,
  onClose: () => void,
  renderFn: ResetPinLayerRenderFn,
  data: ResetPinLayerData,
) => {
  const layerManager = useLayerManager();
  const hasOpenedRef = useRef(false);
  const layerHandle = useRef<{ close: () => void } | null>(null);
  const bridge = LayerDataBridge.getInstance<ResetPinLayerData>(BRIDGE_KEYS.RESET_PIN);

  React.useEffect(() => {
    if (!active) return;
    bridge.setData(data);
  }, [active, data]);

  React.useEffect(() => {
    if (active && !hasOpenedRef.current && layerManager) {
      hasOpenedRef.current = true;
      bridge.setData(data);
      layerHandle.current = layerManager.openInteractionLayer(
        renderFn,
        { dataBridge: bridge },
        {
          size: 'E' as any,
          shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
          onClose: (_state: any, _response: any) => {
            hasOpenedRef.current = false;
            layerHandle.current = null;
            bridge.setData(null);
            onClose();
          },
        },
      );
    }
    if (!active) {
      hasOpenedRef.current = false;
      layerHandle.current?.close();
    }
  }, [active]);
};
